
import vSelect from './vselect'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async doQuery () {
console.log('开始时间')
console.log(this.begin_year)
console.log('结束时间')
console.log(this.end_year)
if (this.begin_year === 0 || this.begin_year === '') {
this.$vux.alert.show({
title: '提示', content: '请选择起始年份！' })
return
}
if (this.end_year !== 0 && this.end_year !== '' && this.end_year < this.begin_year) {
this.$vux.alert.show({
title: '提示', content: '结束年份应大于等于起始年份！' })
return
}
if (this.keyword === '') {
this.$vux.alert.show({
title: '提示', content: '请输入商品关键字！' })
return
}
if ((this.chy === true && this.usd === true) || (this.chy === false && this.usd === false)) {
this.$vux.alert.show({
title: '提示', content: '请选择一种币制！' })
return
}
var iecount = 0
if (this.ieflag === true) {
iecount += 1
}
if (this.iflag === true) {
iecount += 1
}
if (this.eflag === true) {
iecount += 1
}
if (iecount === 0) {
this.$vux.alert.show({
title: '提示', content: '至少需要选择一种进出口方式！' })
return
}
if (this.begin_year === '') {
this.begin_year = 0
}
if (this.end_year === '') {
this.end_year = 0
}
this.$router.push({name: 'GoodsSizeDetails', params: {begin_year: this.begin_year, end_year: this.end_year, country: this.country, dis_country: this.dis_country, goods: this.goods, keyword: this.keyword, trademode: this.trademode, checkdis: this.checkdis, begin_index: this.begin_index, end_index: this.end_index, ieflag: this.ieflag, iflag: this.iflag, eflag: this.eflag, usd: this.usd, chy: this.chy, inoutover: this.inoutover, yearchack: this.yearchack, shipmode: this.shipmode, chacks: this.chacks, chapter: this.chapter, unit: this.unit, importcountry: this.importcountry, exportcountry: this.exportcountry, inareadis: this.inareadis, customs: this.customs, companynature: this.companynature, top: this.top, number: this.numbers}})
},
async getYears () {
const queryPromise = await this.$http.get('/API/TradeStat/GetGoodSizeYear?enumtype=' + this.$route.query.code)
return queryPromise.data
},
getChapter: async function () {
const queryPromise = await this.$http.get('/API/TradeStat/Chapter')
let data = []
for (let i = 0; i < queryPromise.data.length; i++) {
let item = queryPromise.data[i].ChapterName
data.push(item)
}
return data
},
GoTo () {
this.$router.push({name: 'GoodsSizeQueryTOP'})
},
async getShipperMode () {
const queryPromise = await this.$http.get('/API/TradeStat/GetShipperMode?enumtype=' + this.$route.query.code)
return queryPromise.data
},
clear () {
this.keyword = ''
this.numbers = ''
this.top = ''
this.begin_index = ''
this.orgincoutry = ''
this.end_index = ''
this.dis_country = ''
this.shipmode = ''
this.customs = ''
this.inareadis = ''
this.checkdis = ''
this.companynature = ''
this.trademode = ''
this.goods = ''
this.begin_year = 0
this.end_year = 0
this.chapter = ''
this.chacks = false
this.country = ''
this.yearchack = false
this.inoutover = false
this.chy = false
this.usd = false
this.eflag = false
this.iflag = false
this.ieflag = false
},
async getTableName () {
let no = this.$route.query.code
this.tableindex = no
const queryPromise = await this.$http.get('/API/TradeStat/GroupTradeByNo'
, {params: {no: no}})
this.tablename = queryPromise.data.G_NAME
if (no === '9') {
this.tablename = '进出口商品目的地/货源地总值表'
}
}
},
data () {
return {
tableindex: 1,
tablename: '',
numbers: '',
top: '',
begin_year: 0,
end_year: 0,
year: 0,
keyword: '',
begin_index: '',
orgincoutry: '',
end_index: '',
dis_country: '',
shipmode: '',
customs: '',
inareadis: '',
checkdis: '',
companynature: '',
trademode: '',
goods: '',
unit: '',
chapter: '',
importcountry: '',
exportcountry: '',
chacks: false,
country: '',
yearchack: false,
inoutover: false,
chy: false,
usd: false,
eflag: false,
iflag: false,
ieflag: false,
g_name: '',
source: '',
source_num: '',
yearList: [
{years: '2017', ID: ''}
],
chapterList: [
{chapters: '', ID: ''}
],
TopList: [
{tops: '', ID: ''},
{tops: 'TOP10', ID: ''},
{tops: 'TOP20', ID: ''},
{tops: 'TOP30', ID: ''},
{tops: 'TOP50', ID: ''},
{tops: 'TOP100', ID: ''}
],
numberList: [
{numberss: '', ID: ''},
{numberss: '2位', ID: ''},
{numberss: '4位', ID: ''},
{numberss: '6位', ID: ''},
{numberss: '8位', ID: ''}
]
}
},
async activated () {
this.getTableName()
this.yearList = (await this.getYears()).sort().reverse()
if (this.yearList.length > 0) {
this.yearList.unshift('')
this.year = this.yearList[0]
}
this.chapterList = (await this.getChapter())
if (this.chapterList.length > 0) {
this.chapterList.unshift('')
this.chapters = this.chapterList[0]
}
}
}



// WEBPACK FOOTER //
// ./src/components/GoodsSizeQuery.vue